
import * as React from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';

import OutlinedInput from '@mui/material/OutlinedInput';
import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AlarmIcon from '@mui/icons-material/Alarm';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import SimCardRoundedIcon from '@mui/icons-material/SimCardRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import SearchIcon from '@mui/icons-material/Search';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import SendIcon from '@mui/icons-material/Send';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import CloseIcon from '@mui/icons-material/Close';
import StopIcon from '@mui/icons-material/Stop';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/system';
import { DataGrid, GridRowsProp, GridColDef,GridRowId,GridToolbar,GridRowSelectionModel, GridRenderCellParams } from '@mui/x-data-grid';
import { FunctionComponent, useEffect, useState } from 'react'
import KsrgrButton from './KsrgrButton'
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';

import {round} from '../../utils'

import {useAuth} from '../../context/AuthContext'
import {Ibu, Iuserinfo,iauthData} from '../../context/AuthContextTypes'

import classes from '../../components/Cart/cart.module.scss';
import { returnBasenameUrl } from '../../utils';
import {
    renderStatus,
    STATUS_OPTIONS,
  } from '../components/cell-renderers';


type PrOrderHT = {
    COMPANY: number;
    FINDOC: number;
    FINCODE: string;
    QTY1: number;
    TRNDATE: string;
    TRDR: number;
    TRDBRANCH: number;
    TRDCODE: number;
    TRDNAME: string;
    ISCANCEL: number;
    ISPRINT: number;
    APPRV: number;
    FULLYTRANSF: number;
    FINSTATES: number;
    BUSUNITS: number;
    SUMAMNT : number;
    QTYPEND: number;
}
type PrOrderDLine = {
    MTRLINES: number;
    MTRL: number;
    MCODE: string;
    MNAME: string;
    QTY1: number;
    QTY1COV: number;
    QTY1CANC: number;
}
type PrOrderDT = {
    COMPANY: number;
    FINDOC: number;
    FINCODE: string;
    QTY1: number;
    TRNDATE: string;
    TRDR: number;
    TRDBRANCH: number;
    TRDCODE: number;
    TRDNAME: string;
    ISCANCEL: number;
    ISPRINT: number;
    APPRV: number;
    FULLYTRANSF: number;
    FINSTATES: number;
    BUSUNITS: number;
    SUMAMNT : number;
    orderlines: PrOrderDLine[]
}

type PrGetOrdersResponseType = {
    success: boolean,
    reply?: string,
    totalcount?: number,
    procstep?: number,
    data?: PrOrderHT[],
    error?: string,
    request?: Object
}

type PrOrderDResponseType = {
    success: boolean,
    reply?: string,
    totalcount?: number,
    procstep?: number,
    data?: PrOrderDT,
    error?: string,
    request?: Object
}

type PrOrderDetailsProps = {
    order: PrOrderDT | {} ;
    cbf: Function
}
const PrOrderDetails = (props:PrOrderDetailsProps) => {
    const prOrderDetailsColumns : GridColDef[] = [  // , width: 150
        { field: 'MCODE',
          type: 'string',
          headerName: 'Κωδ.Είδους',
          disableReorder: true,
          hideable: false,
          flex:1
        },
        {
          field: 'MNAME',
          type: 'string',
          headerName: 'Περιγραφή είδους',
          disableReorder: true,
          hideable: false,
          flex:2
        },
        { field: 'QTY1',
        type: 'number',
        headerName: 'Z.Ποσ.',
        disableReorder: true,
        hideable: false,
        flex:1
        },
        { field: 'QTY1COV',
            type: 'number',
            headerName: 'Εκτ.Ποσ.',
            disableReorder: true,
            hideable: false,
            flex:1
        },
        { field: 'QTY1CANC',
            type: 'number',
            headerName: 'Ακυρ.Ποσ.',
            disableReorder: true,
            hideable: false,
            flex:1
        },        
        {
          field: 'MTRLINES',
          type: 'number',
          headerName: ' α/α ',
          disableReorder: true,
          hideable: false,
          flex:1
        }
    ]
    type Order = 'asc' | 'desc';
    function getRowId(row:PrOrderDLine) {
      return row.MTRLINES;
    }
    let rows:PrOrderDLine[] = [] 

    let fincode = '';
    let trndate = '';
    let sumamnt = 0.0;
    let iscancel=0;
    let fullytransf = 0;
    let status = '';
    const isSPrOrderDTwHeaderData = (data: any): data is PrOrderDT =>
        typeof data === 'object' && data !== null && data.hasOwnProperty('FINCODE') &&  
    data.hasOwnProperty('TRNDATE') && data.hasOwnProperty('ISCANCEL') && data.hasOwnProperty('FULLYTRANSF') && data.hasOwnProperty('SUMAMNT') ;
    if(isSPrOrderDTwHeaderData(props.order))
    {
        fincode = props.order.FINCODE;
        trndate = props.order.TRNDATE;
        sumamnt = props.order.SUMAMNT;
        iscancel=props.order.ISCANCEL;
        fullytransf = props.order.FULLYTRANSF;
        if(iscancel!==0) status = "Ακυρωμένη"
        else if(fullytransf==0) status = "Σε επεξεργασία"
        else if(fullytransf==1) status = "Εκτελεσμένη"
        else  status = "Μερικώς Εκτελεσμένη"
    }


    const isSPrOrderDTwOrderlines = (data: any): data is PrOrderDT =>
        typeof data === 'object' && data !== null && data.hasOwnProperty('orderlines')  ;

    if(isSPrOrderDTwOrderlines(props.order))
    {
        rows = props.order.orderlines
    }
    function handleClosebtn(){
        props.cbf()
    }

    return (
        <div className={classes.container}>
        <h5>{`Παραγγελία ${fincode} , ${trndate} , ${status}`} </h5>
        <DataGrid rows={rows} columns={prOrderDetailsColumns} getRowId={getRowId} density={'compact'}
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
        }}
        pageSizeOptions={[25, 50]}
        disableColumnMenu        
        checkboxSelection={false}   
        disableMultipleRowSelection={true}
        onRowSelectionModelChange = {(rowSelectionModel, details) => {
        }}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          columnsManagement: {
            toggleAllMode: 'filteredOnly',          
          },       
          filterPanel: {
            disableAddFilterButton: true,
            disableRemoveAllButton: true,
          },
          toolbar: {printOptions: { disableToolbarButton: true },csvOptions: { disableToolbarButton: true },}
        }} 
      />
      <Box>
      <Button variant="contained" endIcon={<StopCircleIcon />} color="warning" onClick={(e)=>{handleClosebtn()}} >κλεισιμο</Button>
      </Box>
      </div>
    )
}


function PrOrders() {
    let auth = useAuth();
    const [prorders, setProrders] = React.useState<PrOrderHT[]>([])
    const [isloading, setIsloading] = React.useState(false)
    const [showdetails, setShowdetails]= React.useState(false)
    const [order, setOrder] = React.useState<PrOrderDT | {}>({})
    
    function retrievemyorders()
    {
        if(auth.userData.success!==true) return
        if(auth.userData.partsaccesslevel===undefined || auth.userData.partsaccesslevel===null || auth.userData.partsaccesslevel<1) {
            console.log('PRORDERS retreivemyorders(), not auth for parts access')
            return
        }
        /* if(auth.userData.partsaccesslevel<2) {
            alert('Posting/ Part Order is now allowed')
            return
        }*/
        // {Ibu, Iuserinfo,iauthData}
        let userinfo:Iuserinfo = auth.userData.userinfo as Iuserinfo
        let uprbu:Ibu  = { 
        WEBSERVICE:0,
        bu: 0,
        buname: '',
        trdr: 0,
        trdbame: '',
        trdbranch: 0,
        trdbrnname: '',
        trdafm: '',
        whs: '',
        accesslevel: 0
        }
        userinfo.bus.forEach( (obu,index, arribu)=>{
        if(obu.bu===20){
            uprbu=obu
        }
        })
        if(uprbu.bu!==20){
            console.log('PRORDERS retreivemyorders(), undefined userino parts bu')
            return
        }
        setIsloading(true)
        setOrder({})
        let token = auth.userData.token
        let usercode = auth.userData.username
        let postdata = {
            service: "getprordersheaders", 
            usercode: usercode,
            userid: auth.userData.userid,
            webservice: uprbu.WEBSERVICE,
            bu: uprbu.bu,
            trdr:  uprbu.trdr,
            trdbranch:  uprbu.trdbranch,
            clientid: token
          }
        let body = JSON.stringify(postdata)
        let basename=returnBasenameUrl()
        let url =`${basename}${process.env.REACT_APP_B2B_API_URL}`;
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: body 
        })
        .then((response) =>  {
            if (!response.ok) return {} 
            else return response.json()
        })
        .then((data:any) => {
            console.log("PRORDERS retreivemyorders(), then ... data=",data)
            const isSuccessPrOrderfoResponse = (data: any): data is PrGetOrdersResponseType =>
            typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ; 
            if (isSuccessPrOrderfoResponse(data) && data.success!==true)
            {
              if(data.hasOwnProperty('error') && typeof data.error === 'string'){
                alert(`Error Querying Parts Order. Reason: ${data.error}`)
              }
              else alert(`Error Querying Parts Order. Reason: unknwon`)
            }
            else {
              // console.log("data.hasOwnProperty('totalcount')",data.hasOwnProperty('totalcount'),"typeof data.totalcount",typeof data.totalcount)
              if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && data.totalcount>0 && typeof data.data === 'object'){
                let responseData = data.data as PrOrderHT[]
                if(responseData.length >0){
                    setProrders(responseData)                
                }
                else {
                    alert(`No Recent Parts Orders Found`)
                }
              }
              else {
                alert(`No Recent Parts Orders Found. TotalCount=0`)
              }
            }
        })
        .catch( (err) =>{   
            alert(`Some Error querying Parts Orders`)   
        })
        .finally(()=>{
            setIsloading(false)
        })
    }

    function retrieveOrderDetails(rowboj:PrOrderHT){
        if(auth.userData.success!==true) return
        if(auth.userData.partsaccesslevel===undefined || auth.userData.partsaccesslevel===null || auth.userData.partsaccesslevel<1) {
            console.log('PRORDERS retrieveOrderDetails, not auth for parts access')
            return
        }
        // {Ibu, Iuserinfo,iauthData}
        let userinfo:Iuserinfo = auth.userData.userinfo as Iuserinfo
        let uprbu:Ibu  = { 
        WEBSERVICE:0,
        bu: 0,
        buname: '',
        trdr: 0,
        trdbame: '',
        trdbranch: 0,
        trdbrnname: '',
        trdafm: '',
        whs: '',
        accesslevel: 0
        }
        userinfo.bus.forEach( (obu,index, arribu)=>{
        if(obu.bu===20){
            uprbu=obu
        }
        })
        if(uprbu.bu!==20){
            console.log('PRORDERS retrieveOrderDetails(), undefined userino parts bu')
            return
        }
        setIsloading(true)
        let token = auth.userData.token
        let usercode = auth.userData.username
        let postdata = {
            service: "getprordersdetails", 
            usercode: usercode,
            userid: auth.userData.userid,
            webservice: uprbu.WEBSERVICE,
            bu: uprbu.bu,
            trdr:  uprbu.trdr,
            trdbranch:  uprbu.trdbranch,
            prorderid: rowboj.FINDOC,
            clientid: token
          }
        let body = JSON.stringify(postdata)
        let basename=returnBasenameUrl()
        let url =`${basename}${process.env.REACT_APP_B2B_API_URL}`;
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: body 
        })
        .then((response) =>  {
            if (!response.ok) return {} 
            else return response.json()
        })
        .then((data:any) => {
            console.log("PRORDERS retrieveOrderDetails(), then ... data=",data)
            const isSuccessPrOrderfoResponse = (data: any): data is PrOrderDResponseType =>
            typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ; 
            if (isSuccessPrOrderfoResponse(data) && data.success!==true)
            {
              if(data.hasOwnProperty('error') && typeof data.error === 'string'){
                alert(`Error Querying Parts Order Details. Reason: ${data.error}`)
              }
              else alert(`Error Querying Parts Order Details. Reason: unknwon`)
            }
            else {
              // console.log("data.hasOwnProperty('totalcount')",data.hasOwnProperty('totalcount'),"typeof data.totalcount",typeof data.totalcount)
              if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && data.totalcount>0 && typeof data.data === 'object'){
                let responseData = data.data as PrOrderDT
                setOrder(responseData)
                setShowdetails(true)
              }
              else {
                alert(`No Parts Order Details Found. TotalCount=0`)
              }
            }
        })
        .catch( (err) =>{   
            alert(`Some Error querying Parts Order Details`)   
        })
        .finally(()=>{
            setIsloading(false)
        })



    }

    function handleCloseDetails()
    {
        setOrder({})
        setShowdetails(false)
    }

    function handleZoomToOrderRow(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, rowboj:PrOrderHT){
        retrieveOrderDetails(rowboj)
    }

    React.useEffect( () =>{
        retrievemyorders();
    },[])

    const prOrderListColumns : GridColDef[] = [  // , width: 150
        { field: 'TRNDATE',
          type: 'string',
          headerName: 'Ημερομηνία',
          disableReorder: true,
          hideable: false,
          flex:1
        },
        {
          field: 'FINCODE',
          type: 'string',
          headerName: 'Παραγγελία',
          disableReorder: true,
          hideable: false,
          flex:2
        },
        { field: 'QTY1',
        type: 'number',
        headerName: 'Z.Ποσ.',
        disableReorder: true,
        hideable: false,
        flex:1
        },
        { field: 'QTYPEND',
            type: 'number',
            headerName: 'Εκκρ.Ποσ.',
            disableReorder: true,
            hideable: false,
            flex:1
        },
        {
          field: 'SUMAMNT',
          type: 'number',
          headerName: 'Σύνολο Αξίας',
          disableReorder: true,
          hideable: false,
          flex:2,
          renderCell: (params: GridRenderCellParams<any, number>) => (
            <strong>
                {params.value ? params.value.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) : params.value }
             </strong>
            ),
        },
        {
            field: 'FULLYTRANSF',
            valueGetter: (value, row:PrOrderHT) => {
                if(row.ISCANCEL!==0){
                    return 'Rejected'
                }
                else {
                    if(row.FULLYTRANSF===0) return 'Open'                    
                    else if(row.FULLYTRANSF===1) return 'Filled' // 'PartiallyFilled', 
                    else return 'PartiallyFilled'
                    //return `${row.firstName || ''} ${row.lastName || ''}`;
                }
            },
            headerName: 'Status',
            renderCell: renderStatus,        
            valueOptions: STATUS_OPTIONS,
            width: 150,
            editable: false,
          },
        {
          field: 'FINDOC',
          type: 'number',
          headerName: ' X ',
          disableReorder: true,
          hideable: false,
          flex:1,
          renderCell: (params: GridRenderCellParams<any, number>) => (
            <strong>
                <IconButton color="primary" aria-label="zoom to order" tabIndex={params.hasFocus ? 0 : -1}
                  onClick={(e)=>{ handleZoomToOrderRow(e, params.row) }}>
                  <ZoomInIcon />
                </IconButton>
              </strong>
            ),
        }
    ]
    type Order = 'asc' | 'desc';
    function getRowId(row:PrOrderHT) {
      return row.FINDOC;
    }

    return (
    <section className={classes.cart}>
      <h1>Παραγγελίες Ανταλλακτικών</h1>
      {isloading===true && <CircularProgress />}
      
      {showdetails === false && <div className={classes.container}>
      <DataGrid rows={prorders} columns={prOrderListColumns} getRowId={getRowId} density={'compact'}
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
        }}
        pageSizeOptions={[25, 50]}
        disableColumnMenu        
        checkboxSelection={false}   
        disableMultipleRowSelection={true}
        onRowSelectionModelChange = {(rowSelectionModel, details) => {
        }}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          columnsManagement: {
            toggleAllMode: 'filteredOnly',          
          },       
          filterPanel: {
            disableAddFilterButton: true,
            disableRemoveAllButton: true,
          },
          toolbar: {printOptions: { disableToolbarButton: true },csvOptions: { disableToolbarButton: true },}
        }} 
      />
      </div> }

      {showdetails == true && <PrOrderDetails order={order} cbf={handleCloseDetails} /> }
             
    </section>
    )
}

export default PrOrders